var map = {
	"./exchange.svg": "8Dd6",
	"./hide.svg": "Elsj",
	"./jiangbei.svg": "eTSO",
	"./keyanfangxiang.svg": "1Rfj",
	"./password.svg": "QjmH",
	"./show.svg": "9Gww",
	"./user.svg": "VdD3",
	"./wenxian.svg": "P1k+",
	"./word.svg": "ELgs",
	"./zhuanli.svg": "the4",
	"./zhuzuoquan.svg": "hhe7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 9